import { render, staticRenderFns } from "./FormClickButton.vue?vue&type=template&id=0649dd34&scoped=true&"
import script from "./FormClickButton.vue?vue&type=script&lang=ts&"
export * from "./FormClickButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0649dd34",
  null
  
)

export default component.exports